export default __webpack_public_path__ + "static/media/ocultar.003a05b0.svg";